import './sentry';
import './bootstrap';
import tippy from "tippy.js";
import { marked } from "marked";
import markedKatex from "marked-katex-extension";
import 'tippy.js/dist/tippy.css';
import "./directives";
import "./components";
import {maskPercentage, maskFloat, maskLatitude, maskLongitude, maskBedAndBath} from "./utils/mask.js";
import {scheduleScrollToFirstError} from "./utils/scrollToError.js";

marked.use(markedKatex({
      throwOnError: false,
      output: 'mathml',
      macros: {
        "\\f": "#1f(#2)"
      }
}));

window.tippy = tippy;
window.marked = marked;

document.addEventListener("livewire:initialized", () => {
    Livewire.hook(
        'element.init',
        (el, component) => setTimeout(
            () => tippy('[data-tippy-content]'),
            700
        )
    );

    Livewire.hook('morph.updating', ({ component, skip }) => {
        if (!component.el.isConnected) {
            skip();
        }
    });
});

document.addEventListener('token::regenerated', (event) => {
    const token = event.detail[0];

    document.querySelectorAll('meta[name="csrf-token"]').forEach((meta) => {
        meta.setAttribute('content', token);
    });
});

document.addEventListener('meta:track', (event) => {
    const { name, customData, method, eventId, userData } = event.detail;

    if (typeof window.fbq !== 'function') {
        return;
    }

    if (window.metaPixelId && userData && Object.keys(userData).length > 0) {
        window.fbq('init', window.metaPixelId, userData);
    }

    if (eventId) {
        window.fbq(method ?? 'track', name, customData, { eventID: eventId });

        return;
    }

    window.fbq(method ?? 'track', name, customData);
});

window.maskPercentage = maskPercentage;
window.maskLatitude = maskLatitude;
window.maskLongitude = maskLongitude;
window.maskFloat = maskFloat;
window.maskBedAndBath = maskBedAndBath;
window.scheduleScrollToFirstError = scheduleScrollToFirstError;
